export const APP_PREFIX = "paws.";

export async function resetEverything(app, storage = globalThis.localStorage) {
  const report = { analisi: 0, feedback: 0, preferenze: 0, errori: [] };
  let items = [];
  try {
    items = await app.history.list();
  } catch (error) {
    report.errori.push("storico non leggibile");
  }
  const withFeedback = items.filter((item) => item.feedbackId);
  if (withFeedback.length && app.feedback?.available) {
    const outcomes = await Promise.allSettled(withFeedback.map((item) => app.feedback.remove(item.feedbackId)));
    report.feedback = outcomes.filter((outcome) => outcome.status === "fulfilled").length;
    if (report.feedback < withFeedback.length) report.errori.push("qualche feedback non è stato eliminato");
  }
  try {
    await app.history.clear();
    report.analisi = items.length;
  } catch (error) {
    report.errori.push("storico non svuotato");
  }
  try {
    const keys = Object.keys(storage || {}).filter((key) => key.startsWith(APP_PREFIX));
    keys.forEach((key) => storage.removeItem(key));
    report.preferenze = keys.length;
  } catch (error) {
    report.errori.push("preferenze non azzerate");
  }
  app.theme?.set("system");
  app.speaker?.stop();
  return report;
}

export function resetSummary(report) {
  const parts = [
    `${report.analisi} analisi eliminate`,
    report.feedback ? `${report.feedback} feedback rimossi dal database` : null,
    report.preferenze ? "preferenze riportate ai valori iniziali" : null
  ].filter(Boolean);
  const text = parts.join(", ");
  return report.errori.length ? `${text} · ${report.errori.join(", ")}` : text;
}
